import { AxiosRequestConfig } from 'axios'

import { CreateAdminPayload, UpdateAdminRolesData } from './types'

const getAdmins = (): AxiosRequestConfig => ({
  url: '/admins',
  method: 'GET',
})

const createAdmin = (adminPayload: CreateAdminPayload): AxiosRequestConfig => ({
  url: '/admins',
  method: 'POST',
  data: { admin: adminPayload },
})

const updateAdminRoles = (data: UpdateAdminRolesData): AxiosRequestConfig => {
  const roleId = typeof data.payload === 'string' ? parseInt(data.payload, 10) : data.payload

  return {
    url: `/admins/${data.id}/roles`,
    method: 'PUT',
    data: {
      roleId,
      ...(data.storeIds !== undefined ? { storeIds: data.storeIds } : {}),
      ...(data.password !== undefined && data.password !== '' ? { password: data.password } : {}),
      ...(data.reportsEnabled !== undefined ? { reportsEnabled: data.reportsEnabled } : {}),
      ...(data.reportFrequencyWeekly !== undefined
        ? { reportFrequencyWeekly: data.reportFrequencyWeekly }
        : {}),
      ...(data.reportFrequencyBiweekly !== undefined
        ? { reportFrequencyBiweekly: data.reportFrequencyBiweekly }
        : {}),
      ...(data.reportFrequencyMonthly !== undefined
        ? { reportFrequencyMonthly: data.reportFrequencyMonthly }
        : {}),
      ...(data.reviewsCanRespond !== undefined
        ? { reviewsCanRespond: data.reviewsCanRespond }
        : {}),
      ...(data.criticalReviewAlertsEnabled !== undefined
        ? { criticalReviewAlertsEnabled: data.criticalReviewAlertsEnabled }
        : {}),
    },
  }
}

const deleteAdmin = (id: number): AxiosRequestConfig => ({
  url: `/admins/${id}`,
  method: 'DELETE',
})

const getRoles = (): AxiosRequestConfig => ({
  url: '/roles',
  method: 'GET',
})

export { getAdmins, createAdmin, updateAdminRoles, deleteAdmin, getRoles }
